import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createPost } from 'reducers/posts/postActions'

class PostForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            body: ''
        };
    }

    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleSubmit(evt) {
        evt.preventDefault();

        const post = {
            title: this.state.title,
            body: this.state.body
        }

        this.props.createPost(post);
    }

    render() {
        return (
            <div>
                <h1>Add Post</h1>
                <form onSubmit={(evt) => this.handleSubmit(evt)}>
                    <div>
                        <label>Title: </label>
                        <br />
                        <input type="text" name="title" value={this.state.title} onChange={(evt) => this.handleChange(evt)} />
                    </div>
                    <br />
                    <div>
                        <label>Body: </label>
                        <br />
                        <textarea name="body" value={this.state.body} onChange={(evt) => this.handleChange(evt)} />
                    </div>
                    <br />
                    <button type="submit">Submit</button>
                </form>
            </div>
        )
    }
}

PostForm.propTypes = {
    createPost: PropTypes.func.isRequired
}

export default connect(null, { createPost })(PostForm);


// WEBPACK FOOTER //
// ./src/components/Posts/PostForm.js